import React from 'react';
import {t} from 'i18next';

const IngestionDetailsToolTip = () => {
  return (
    <div
      style={{maxWidth: 900, margin: 'auto'}}
      data-testid={`ingestion-details-tool-tip-intro1-title-description-title-desc-title-desc-title-desc-title-desc-title-desc1-desc2-desc3-title-desc1-desc2-note-title-desc-title-title-desc-title-desc-title-desc`}>
      {/* Introduction */}
      <p data-testid={`ingestion-details-tool-tip-intro1`}>{t('ingestions.details.tooltip.intro1')}</p>
      <hr data-testid={`ingestion-details-tool-tip-hr`} />
      {/* Ingestion Steps */}
      <h3 data-testid={`ingestion-details-tool-tip-title`}>{t('ingestions.details.tooltip.steps.title')}</h3>
      <p data-testid={`ingestion-details-tool-tip-description`}>{t('ingestions.details.tooltip.steps.description')}</p>
      <ul
        data-testid={`ingestion-details-tool-tip-title-desc-title-desc-title-desc-title-desc`}>
        <li data-testid={`ingestion-details-tool-tip-title-desc`}>
          <strong data-testid={`ingestion-details-tool-tip-title-btn`}>
            {t('ingestions.details.tooltip.steps.cataloging.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc`}>{t('ingestions.details.tooltip.steps.cataloging.desc')}</p>
        </li>
        <li data-testid={`ingestion-details-tool-tip-title-desc-btn`}>
          <strong data-testid={`ingestion-details-tool-tip-title-button`}>{t('ingestions.details.tooltip.steps.copying.title')}</strong>
          <p data-testid={`ingestion-details-tool-tip-desc-text`}>{t('ingestions.details.tooltip.steps.copying.desc')}</p>
        </li>
        <li data-testid={`ingestion-details-tool-tip-title-desc-button`}>
          <strong data-testid={`ingestion-details-tool-tip-title-icon`}>
            {t('ingestions.details.tooltip.steps.indexing.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc-btn`}>{t('ingestions.details.tooltip.steps.indexing.desc')}</p>
        </li>
        <li data-testid={`ingestion-details-tool-tip-title-desc-icon`}>
          <strong data-testid={`ingestion-details-tool-tip-title-link`}>
            {t('ingestions.details.tooltip.steps.approving.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc-button`}>{t('ingestions.details.tooltip.steps.approving.desc')}</p>
        </li>
      </ul>
      <hr data-testid={`ingestion-details-tool-tip-hr-btn`} />
      {/* Ingestion Statuses */}
      <h3 data-testid={`ingestion-details-tool-tip-title-input`}>{t('ingestions.details.tooltip.statuses.title')}</h3>
      <p data-testid={`ingestion-details-tool-tip-desc1`}>{t('ingestions.details.tooltip.statuses.desc1')}</p>
      <p data-testid={`ingestion-details-tool-tip-desc2`}>{t('ingestions.details.tooltip.statuses.desc2')}</p>
      <p data-testid={`ingestion-details-tool-tip-desc3`}>{t('ingestions.details.tooltip.statuses.desc3')}</p>
      <hr data-testid={`ingestion-details-tool-tip-hr-button`} />
      {/* Error Handling */}
      <h3 data-testid={`ingestion-details-tool-tip-title-text`}>{t('ingestions.details.tooltip.errors.title')}</h3>
      <p data-testid={`ingestion-details-tool-tip-desc1-text`}>{t('ingestions.details.tooltip.errors.desc1')}</p>
      <p data-testid={`ingestion-details-tool-tip-desc2-text`}>{t('ingestions.details.tooltip.errors.desc2')}</p>
      <p data-testid={`ingestion-details-tool-tip-note`}>{t('ingestions.details.tooltip.errors.note')}</p>
      <hr data-testid={`ingestion-details-tool-tip-hr-icon`} />
      {/* Rollback */}
      <h3 data-testid={`ingestion-details-tool-tip-title-container`}>{t('ingestions.details.tooltip.rollback.title')}</h3>
      <p data-testid={`ingestion-details-tool-tip-desc-icon`}>{t('ingestions.details.tooltip.rollback.desc')}</p>
      <hr data-testid={`ingestion-details-tool-tip-hr-link`} />
      {/* Other Actions */}
      <h3 data-testid={`ingestion-details-tool-tip-title-2`}>{t('ingestions.details.tooltip.otherActions.title')}</h3>
      <ul
        data-testid={`ingestion-details-tool-tip-title-desc-title-desc-title-desc`}>
        <li data-testid={`ingestion-details-tool-tip-title-desc-link`}>
          <strong data-testid={`ingestion-details-tool-tip-title-3`}>
            {t('ingestions.details.tooltip.otherActions.delete.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc-link`}>{t('ingestions.details.tooltip.otherActions.delete.desc')}</p>
        </li>
        <li data-testid={`ingestion-details-tool-tip-title-desc-input`}>
          <strong data-testid={`ingestion-details-tool-tip-title-4`}>
            {t('ingestions.details.tooltip.otherActions.copy.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc-input`}>{t('ingestions.details.tooltip.otherActions.copy.desc')}</p>
        </li>
        <li data-testid={`ingestion-details-tool-tip-title-desc-text`}>
          <strong data-testid={`ingestion-details-tool-tip-title-5`}>
            {t('ingestions.details.tooltip.otherActions.openInWizard.title')}
          </strong>
          <p data-testid={`ingestion-details-tool-tip-desc-container`}>
            {t('ingestions.details.tooltip.otherActions.openInWizard.desc')}
          </p>
        </li>
      </ul>
    </div>
  );
};

export default IngestionDetailsToolTip;
